import { Checkbox } from '@doda/io-react/common';
import { ChangeEvent, FC } from 'react';
import styles from './index.module.scss';
import { DrillDownText } from '../DrillDownText';

/**
 * 配列要素の型定義
 * @param id
 * @param title
 * @param jobCount
 * @param isChecked チェックボックスのチェック状態
 * @param url 遷移先URL
 */
interface ListType {
  id: string;
  title: string;
  jobCount: string;
  isChecked: boolean;
  url?: string | null;
}

/**
 * 業種ドリルダウンの型定義
 * @param id
 * @param title
 * @param jobCount
 * @param list
 * @param url
 * @param isChecked
 */
export interface IndustryDrillDownType {
  id: string;
  title: string;
  jobCount: string;
  list: ListType[];
  url?: string | null;
  isChecked: boolean;
}

/**
 * Propsの型定義
 * @param drillDown 業種ドリルダウン
 * @param onChange チェックボックス更新処理
 */
interface Props {
  drillDown: IndustryDrillDownType;
  onChange: (event: ChangeEvent<HTMLInputElement>, selectedId: string) => void;
}

export const IndustryDrillDown: FC<Props> = ({ drillDown, onChange }) => {
  return (
    <div className={styles.industryDrillDown}>
      <DrillDownText
        title={drillDown.title}
        jobCount={drillDown.jobCount}
        url={drillDown.url}
        size="L"
      />
      <ul className={styles.industryDrillDown__list}>
        {drillDown.list.map((item) => {
          return (
            <li key={item.id}>
              <Checkbox
                label={
                  <DrillDownText
                    title={item.title}
                    jobCount={item.jobCount}
                    url={item.url}
                    isBold={item.isChecked}
                  />
                }
                value={item.id}
                checked={item.isChecked}
                onChange={(event) => {
                  if (item.url) {
                    onChange(event, item.id);
                  }
                }}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
